<template>

  <div v-if="!hasDebt" class="pa-4">
<!--     <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">Неоплаченных счетов не найдено</v-list-item-title>
        <v-list-item-subtitle>{{searchResult.address}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <div class="pa-4">По указанному лицевому счету задолженность не найдена</div>
    <div class="d-flex pa-4">
      <v-spacer />
      <v-btn depressed color="primary" @click.stop="close">Назад</v-btn>
    </div> -->
  

    <v-alert border="left" type="info" text prominent>
      Задолженность и/или неоплаченные услуги по данному лицевому счету отсутсвуют.
    </v-alert>
    
  </div>

  <div v-else>


  <!--   <v-list-item two-line>

      <v-list-item-content>
        <v-list-item-title class="headline">Оплата услуг</v-list-item-title>
        <v-list-item-subtitle>{{searchResult.address}}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn icon @click.stop="close" large>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item> -->

    <div style="max-height: 303px; overflow: auto">
      <v-list-item v-for="service in services" :key="service.guid" class="opacity-off" two-line>

        <v-list-item-content style="padding-top: 8px; padding-bottom: 8px">
          {{service.name}}
        </v-list-item-content>

        <v-list-item-content style="max-width: 90px; ">
          <div style="font-size: 16px; text-align: right">
            {{Math.max(service.debt, 0) | fin | rub }}
          </div>
        </v-list-item-content>

        <v-list-item-action>
          <v-switch :input-value="selected" :value="service.guid" :loading="recalc"
            :disabled="recalc || service.debt <= 0" readonly @click="togglePayment(service)" />
        </v-list-item-action>

      </v-list-item>
    </div>



    <v-divider inset />

    <div class="px-4 pt-2">

      <div class="d-flex justify-end align-center">

        <img :src="selectedPaySystem.image" height="48" class="mr-5" />

        <div>
          <div class="headline text-right">Итого к оплате: <span
              class="text-no-wrap">{{ totalAmount | fin | rub}}</span></div>
          <div class="body-1 text-right grey--text">в том числе комиссия: <span
              class="text-no-wrap">{{ totalCommission | fin | rub }}</span></div>
        </div>
      </div>

      <v-text-field v-model="phoneEmail" label="Телефон или email для получения чека" autocomplete="on" type="tel"></v-text-field>
      <v-checkbox v-show="enableCanRegister" v-model="register" class="ma-0"
        label="Получить доступ к истории платежей в Системе Город" hide-details />

    </div>


    <div class="px-4 pt-3">
      
      <form :action="$api.url+'Pay'" autocomplete="off" target="_blank" method="POST"> 

          <input type="hidden" name="provider" :value="$store.state.options.providerGuid"/>
          <input type="hidden" name="paySystem" :value="selectedPaySystem.guid" />
          <input type="hidden" name="needRegister" :value="canRegister && enableCanRegister && register"/>
          <input v-if="!!phoneEmail" type="hidden" name="phoneEmail" :value="phoneEmail"/>
          <input v-for="service in services2" :key="service.guid" type="hidden" name="amount" :value="service.guid+':'+service.debt" />

          <v-btn x-large class="title" depressed color="primary" block @click="save" type="submit" :disabled="disabledPay">
            Согласен,
            Оплатить</v-btn>
      </form>
      



      <span v-if="offerUrl" class="caption">Пользуясь данным сервисом Вы соглашаетесь с <a :href="offerUrl"
          target="_blank" rel="noopener noreferrer">Офертой</a>
      </span>

    </div>

  </div>



</template>

<script>
  import paymentsMixin from '@/mixins/paymentsMixin'

  export default {
    mixins: [paymentsMixin],
    watch: {
      selectedPaySystem() {
        this.recalculate()
      },
      searchResult() {
        this.selected = this.services.map(serv => serv.guid)
      },
    },
    computed: {

      services2() {
        return this.services.filter(serv => serv.debt > 0 && this.selected.indexOf(serv.guid) != -1);
      },

      hasDebt() {
        return this.searchResult.services.some(service => service.debt > 0)
      },

      _selectedGuids() {
        return this.selectedGuids;
      },

      paySystems() {
        return this.searchResult.paySystems
      },

      offerUrl() {
        return this.selectedPaySystem.offerUrl
      },

      disabledPay() {
        return this.selected.length == 0 || this.total.total == 0
      },
    },
    data() {
      return {
        selected: this.searchResult.services.filter(serv => serv.debt > 0).map(serv => serv.guid),
      }
    },

    methods: {

      togglePayment(service) {
        if (!service) {
          return
        }

        if (this.recalc || service.debt <= 0) {
          return
        }

        let guid = service.guid

        let selected = [...this.selected]
        let index = selected.indexOf(guid)

        if (index != -1) {
          selected.splice(index, 1)
        } else {
          selected.push(guid)
        }

        if (selected.length == 0) {
          this.total = {
            total: 0,
            commission: 0
          }
          this.selected = selected
          return
        }

        this.calcTotal(this.getServicesSumm(selected))
          .then(res => {
            this.selected = selected
          })
      },

      close() {
        this.$router.push({
          name: 'search'
        })
        this.postMessage('dialog:close')
      },

      getServicesSumm(selected) {
        return this.services
          .filter(service => selected.indexOf(service.guid) != -1)
          .reduce((res, serv) => {
            res[serv.guid] = serv.debt
            return res
          }, {})
      },

      recalculate() {
        if (this.recalc)
          return

        if (!this.selected || this.selected.length == 0) {
          this.total = {
            total: 0,
            commission: 0
          }
          return
        }

        this.calcTotal(this.getServicesSumm(this.selected))
      },

      save(e) {

        if (!this.selectedPaySystem) return

        if (!this.selected || this.selected.length == 0) return;

        if (this.recalc || this.saving) return

  
                setTimeout(()=> {
                    this.$eventBus.$emit('loader:hide')
                    if (this.openNewTab && !this.wgStandAlone && this.closeOnAccept) {
                        this.$router.push({
                            name: 'search'
                        })
                        this.postMessage('dialog:close')
                    }
                }, 2000)      

      }

    }
  }
</script>

<style>
  .opacity-off.theme--light.v-list-item--active:hover::before,
  .opacity-off.theme--light.v-list-item--active::before {
    opacity: 0 !important;
  }
</style>